import axios from '../axios'

const deleteModuleMaterialApi = async (materialId) => {
  return await axios.delete(`api/lms/module-materials/${materialId}`)
}

export default deleteModuleMaterialApi
